import { GET_WHITELIST, RESET_WHITELIST_SEARCH, GET_WHITELIST_SEARCH } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getWhitelist = (unitID) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/whitelist`, options))

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to fetch whitelist.')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_WHITELIST,
        payload: data
      })
    }
  }
}

export const addWhitelistItem = (unitID, whitelistInfo, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { ...whitelistInfo, createdBy: supervisorID }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/whitelist`, options))

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to add whitelist item.')
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const updateWhitelistItem = (supervisorID, unitID, whitelistID, whitelistInfo, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...whitelistInfo }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(
      window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/whitelist/${whitelistID}`, options)
    )

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to update whitelist item.')
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const deleteWhitelistItem = (unitID, whitelistID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(
      window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/whitelist/${whitelistID}`, options)
    )

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to delete whitelist item.')
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const getWhiteListSearch = (unitID, searchText, siteInfo, fireFound, fireNotFound) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { searchText }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(
      window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/whitelist/search`, options)
    )

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      log.warn('Error: Failed to fetch search results from whitelist.')
    } else {
      const { data } = await response.json()
      if (data.length === 0) {
        // if website is NOT in the database
        dispatch({
          type: RESET_WHITELIST_SEARCH,
          payload: []
        })
        fireNotFound(siteInfo)
        return false
      } else {
        // if website IS in database
        dispatch({
          type: GET_WHITELIST_SEARCH,
          payload: data
        })
        fireFound()
        return true
      }
    }
  }
}

export const resetWhiteListSearch = () => {
  return function (dispatch) {
    dispatch({
      type: RESET_WHITELIST_SEARCH,
      payload: []
    })
  }
}
